var getNative = require("./_getNative"),
    root = require("./_root");
/* Built-in method references that are verified to be native. */


var DataView = getNative(root, 'DataView');
module.exports = DataView;